
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { request as __request } from '@/api/core/request';
import NIcon from '@/uikit/icons/NIcon.vue';
import DragHelper from './DragHelper';
import { configModule } from '@/store/config';

@Options({
  name: 'VideoPlayerPtzPanel',
  components: { NIcon },
  directives: { DragHelper }
})
export default class VideoPlayerPtzPanel extends Vue {
  @Prop({ type: Number, required: true })
  readonly cameraId!: number;

  get defaultPosition() {
    return configModule.config?.video_player?.onvif?.ptz?.defaultPosition || { pan: 1e-6, tilt: 1e-6 };
  }

  updatePosition(dx: number, dy: number) {
    const pan = dx / 20;
    const tilt = dy / 20;
    __request({
      method: 'POST',
      path: `/cameras/${this.cameraId}/ptz/`,
      body: {
        movement_type: 'relative',
        pan,
        tilt
      }
    });
  }

  resetPosition() {
    __request({
      method: 'POST',
      path: `/cameras/${this.cameraId}/ptz/`,
      body: {
        movement_type: 'absolute',
        pan: this.defaultPosition.pan,
        tilt: this.defaultPosition.tilt
      }
    });
  }

  async updateZoom(delta: number) {
    try {
      await __request({
        method: 'POST',
        path: `/cameras/${this.cameraId}/ptz/`,
        body: {
          movement_type: 'relative',
          zoom: delta / 20
        }
      });
    } catch (e) {
      console.log(String(e));
    }
  }
}
